(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
          if (window.innerWidth > 767) {
            window.initAllEmblaCarousels();
          }
        }

        document.querySelectorAll('form[action="/cart/add"]').forEach((form) => {
          form.addEventListener('submit', async (e) => {
            e.preventDefault();
            const formData = new FormData(form);
            const addRes = await fetch('/cart/add.js', {
              method: 'POST',
              body: formData,
              headers: { Accept: 'application/json' },
            });

            if (!addRes.ok) {
              console.error('Add to cart failed');
              return;
            }

            const added = await addRes.json(); // ← single added line_item

            // 2) Update cart count (entire cart)
            const res = await fetch('/cart.js');
            const cart = await res.json();
            window.updateCartItemCounts(cart.item_count);

            // 3) Update cart drawer (your existing function)
            await window.updateCartDrawer();

            const qtyJustAdded = window.getAddedQuantityFromFormData(formData); // ← 1, or sum of items[n][quantity]

            // 4) Fill cart-notification
            window.fillCartNotification(added, qtyJustAdded);

            // 5) Show notification (your existing function)
            window.openCartNotification();
          });
        });
      })
      .catch((e) => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 200px 0px' });

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();
})();
